import { MembershipPlan, PLAN_CODES, PlanCode } from './membership.constants';

type PaywallLinkParams =
  | { hasActiveMembership: boolean; source?: string }
  | { focusedPlan: MembershipPlan | 'teams' | 'donate'; source?: string };

type PaywallLink = {
  url: string;
  pathname: string;
  search?: string;
};

export const isRecurringMembership = (planCode: PlanCode): boolean =>
  planCode !== PLAN_CODES.NO_RENEW;

export const getPaywallLink = (params: PaywallLinkParams): PaywallLink => {
  if ('hasActiveMembership' in params) {
    const pathname = params.hasActiveMembership ? '/membership' : '/support_us';

    const search = params.source
      ? `?${new URLSearchParams({ source: params.source }).toString()}`
      : undefined;

    return {
      url: `${pathname}${search ?? ''}`,
      pathname,
      search,
    };
  }

  const pathname = '/support_us';
  const searchParams = new URLSearchParams({
    plan: params.focusedPlan,
    ...(params.source ? { source: params.source } : {}),
  });
  const search = `?${searchParams.toString()}`;

  return {
    url: `${pathname}${search}`,
    pathname,
    search,
  };
};
